import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../../state/store";
import { getCareRecipientListAction } from "../../../../../state/usecase/admin/care_recipient/actions";
import { initAssessmentInfoAction } from "../../../../../state/usecase/assessment/info/actions";
import { initAssessmentScheduleAction } from "../../../../../state/usecase/assessment/schedule/actions";
import { initExtractedDiseasesAction } from "../../../../../state/usecase/disease_knowledge/actions";
import { CareRecipientAdd } from "./CareRecipientAdd";
import { CareRecipientsHideSwitch } from "./CareRecipientsHideSwitch";
import { CareRecipientsSearch } from "./CareRecipientsSearch";
import { CareRecipientsTable } from "./CareRecipientsTable";

export const CareRecipients = React.memo(function CareRecipients() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getCareRecipientListAction());
        dispatch(initAssessmentInfoAction());
        dispatch(initAssessmentScheduleAction());
        dispatch(initExtractedDiseasesAction());
    }, [dispatch]);

    return (
        <>
            {/* ページサブタイトル */}
            <h2 className="sub_title">利用者一覧</h2>
            {/* ハウスID・利用者名検索ボックス */}
            <CareRecipientsSearch />
            {/* 利用者追加ボタン */}
            <CareRecipientAdd />
            {/* データ連携終了者非表示スイッチ */}
            <CareRecipientsHideSwitch />
            {/* 利用者の表 */}
            <CareRecipientsTable />
        </>
    );
});
